module.exports = __webpack_public_path__ + "static/media/10.96962d90.png";